<div
  class="layout-container layout-light layout-static layout-topbar-light layout-menu-dim"
>
  <header>
    <div class="layout-topbar">
      <div class="layout-topbar-start">
        <a routerlink="/" class="layout-topbar-logo" href="/">
          <img alt="ForceN Logo" src="assets/img/logo_force_n.png" />
        </a>
      </div>
      <div class="layout-topbar-end surface-border">
        <div class="layout-topbar-actions-start">
          <a
            pripple=""
            class="p-ripple p-element layout-menu-button lg:flex ng-star-inserted transition"
          >
            <i class="pi pi-bars"></i>
            <span
              class="p-ink"
              aria-hidden="true"
              role="presentation"
              style="height: 35px; width: 35px; top: 4.5px; left: 0px"
            ></span>
          </a>
        </div>
        <div class="layout-topbar-actions-end">
          <!-- profil -->
          <div class="flex items-center ms-3 cst-user-panel">
            <button
              pbutton=""
              pripple=""
              type="button"
              icon="pi pi-user"
              class="p-element p-ripple p-button-rounded p-button-info p-button p-component p-button-icon-only"
              style="background-color: var(--blue)"
            >
              <span class="p-button-icon pi pi-user" aria-hidden="true"></span>
            </button>
            <div
              class="dropdownuser z-50 my-4 text-base list-none bg-white divide-y divide-gray-100 rounded shadow dark:bg-gray-700 dark:divide-gray-600"
              id="dropdownuser"
            >
              <div class="px-4 py-3" role="none">
                <div class="flex">
                  <button
                    pbutton=""
                    pripple=""
                    type="button"
                    icon="pi pi-user"
                    class="p-element p-ripple p-button-rounded p-button-info p-button p-component p-button-icon-only mr-2"
                    style="background-color: var(--blue)"
                  >
                    <span
                      class="p-button-icon pi pi-user"
                      aria-hidden="true"
                    ></span>
                  </button>
                  <div>
                    <p
                      class="text-sm text-gray-900 dark:text-white font-semibold mb-0"
                      role="none"
                    >
                      {{ fullname }}
                    </p>
                    <p
                      class="text-sm text-gray-900 truncate dark:text-gray-300"
                      role="none"
                    >
                      {{ email }}
                    </p>
                  </div>
                </div>
              </div>
              <ul class="font-medium border-gray-200" role="none">
                <li>
                  <a
                    [routerLink]="['/dashboard/users/profil']"
                    class="flex items-center px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700"
                    routerLinkActive="active-link"
                  >
                    <svg
                      style="width: 1em"
                      class="text-blue"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 14 18"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="M7 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-2 3h4a4 4 0 0 1 4 4v2H1v-2a4 4 0 0 1 4-4Z"
                      />
                    </svg>
                    <span class="flex-1 ms-3 whitespace-nowrap"
                      >Mon Profil</span
                    >
                  </a>
                </li>
                <div *ngIf="profil == 1 && eleve === false">
                  <hr class="bg-gray-200 my-0" />
                  <li
                    *ngIf="
                      !coursera_user ||
                      cohorte == parcours3 || cohorte == parcours4 || cohorte
                    "
                  >
                    <a
                      [routerLink]="['agenda/apprenant']"
                      class="flex items-center px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700"
                      routerLinkActive="active-link"
                    >
                      <svg
                        style="width: 1em"
                        class="text-blue"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 18 20"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="m9 17 8 2L9 1 1 19l8-2Zm0 0V9"
                        />
                      </svg>
                      <span class="flex-1 ms-3 whitespace-nowrap"
                        >Mon SIGUI</span
                      >
                    </a>
                  </li>
                  <hr class="bg-gray-200 my-0" />
                  <li>
                    <a
                      [routerLink]="['users/portfolio']"
                      class="flex items-center px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700"
                      routerLinkActive="active-link"
                    >
                      <svg
                        style="width: 1em"
                        class="text-blue"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M9 5h6M9 8h6m-6 3h6M4.996 5h.01m-.01 3h.01m-.01 3h.01M2 1h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1Z"
                        />
                      </svg>
                      <span class="flex-1 ms-3 whitespace-nowrap"
                        >Mon portfolio</span
                      >
                    </a>
                  </li>
                </div>
                <div *ngIf="profil == 1 && eleve === true">
                  <hr class="h-px bg-gray-200 border-0 dark:bg-gray-700" />
                  <li>
                    <a
                      [routerLink]="['/dashboard/elab']"
                      class="flex items-center px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700"
                      routerLinkActive="active-link"
                    >
                      <svg
                        style="width: 1em"
                        class="text-blue"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 18 20"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="m9 17 8 2L9 1 1 19l8-2Zm0 0V9"
                        />
                      </svg>
                      <span class="flex-1 ms-3 whitespace-nowrap">E-lab</span>
                    </a>
                  </li>
                  <hr class="bg-gray-200 my-0" />
                  <li>
                    <a
                      [routerLink]="['/dashboard/bibliotheque']"
                      class="flex items-center px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700"
                      routerLinkActive="active-link"
                    >
                      <svg
                        style="width: 1em"
                        class="text-blue"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M9 5h6M9 8h6m-6 3h6M4.996 5h.01m-.01 3h.01m-.01 3h.01M2 1h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1Z"
                        />
                      </svg>
                      <span class="flex-1 ms-3 whitespace-nowrap"
                        >Bibliothèque</span
                      >
                    </a>
                  </li>
                </div>

                <hr class="bg-gray-200 my-0" />
                <li>
                  <a
                    [routerLink]="['/dashboard/users/profil']"
                    class="flex items-center px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700"
                    routerLinkActive="active-link"
                  >
                    <svg
                      style="width: 1em"
                      class="text-blue"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 20 20"
                    >
                      <g
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <path
                          d="M19 11V9a1 1 0 0 0-1-1h-.757l-.707-1.707.535-.536a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0l-.536.535L12 2.757V2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v.757l-1.707.707-.536-.535a1 1 0 0 0-1.414 0L2.929 4.343a1 1 0 0 0 0 1.414l.536.536L2.757 8H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.757l.707 1.707-.535.536a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l.536-.535L8 17.243V18a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-.757l1.707-.708.536.536a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414l-.535-.536.707-1.707H18a1 1 0 0 0 1-1Z"
                        />
                        <path d="M10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                      </g>
                    </svg>
                    <span class="flex-1 ms-3 whitespace-nowrap"
                      >Paramètre du compte</span
                    >
                  </a>
                </li>
                <hr class="bg-gray-200 my-0" />
                <li>
                  <a
                    [routerLink]="['/dashboard/users/profil']"
                    class="flex items-center px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700"
                    routerLinkActive="active-link"
                  >
                    <svg
                      style="width: 1em"
                      class="text-blue"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 20 20"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M8 9h2v5m-2 0h4M9.408 5.5h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                    <span class="flex-1 ms-3 whitespace-nowrap">Support</span>
                  </a>
                </li>
                <hr class="bg-gray-200 my-0" />
                <li>
                  <a
                    (click)="logout()"
                    class="flex items-center px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer"
                    routerLinkActive="active-link"
                  >
                    <svg
                      style="width: 1em"
                      class="text-blue"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 16 16"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 8h11m0 0-4-4m4 4-4 4m-5 3H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3"
                      />
                    </svg>
                    <span class="flex-1 ms-3 whitespace-nowrap"
                      >Déconnexion</span
                    >
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</div>
